<template>
  <div
    v-if="$route.name === 'checkDetailsPage'"
    class="page-content"
  >
    <div class="tab-content">
      <a-page-header
        :title="groupName"
        :sub-title="`第${lessonNum}讲      ` + lessonName"
        @back="() => $router.replace({name: 'classList', params: {noRefreshGroup: true}})"
      />
      <a-layout>
        <a-layout-sider width="156px">
          <a-menu
            :default-selected-keys="status"
            width="156px"
            mode="vertical"
            @click="handleClick"
          >
            <a-menu-item key="1">
              <a-icon type="calendar" />
              待批改
            </a-menu-item>
            <a-menu-item key="2">
              <a-icon type="calendar" />
              未提交
            </a-menu-item>
            <a-menu-item key="3">
              <a-icon type="calendar" />
              已批改
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout-content class="main-content">
          <a-layout
            v-if="status === '1'"
            style="background: #fff"
          >
            <a-layout-sider
              width="130"
              class="check-detail-student"
              style="background: #fff"
            >
              <div
                class="studentbox"
                @click="handleGetStudentSubmitData"
              >
                <div
                  v-for="(item, index) in studentInfo"
                  :key="index"
                >
                  <h4>{{ item.linkTypeName }}</h4>
                  <p
                    v-for="(subItem, subIndex) in item.studentInfoList"
                    :key="subIndex"
                    :data-index="subIndex"
                    :data-ptindex="index"
                    :data-linktype="item.linkType"
                    :data-userid="subItem.userId"
                    :data-typename="item.linkTypeName"
                    :data-username="subItem.userName"
                    :class="['student-name', {'active': curIndex == subIndex && curPtIndex == index}]"
                    :ref="'stu'+index+subIndex"
                    :title="subItem.userName"
                  >
                    {{ subItem.userName }}
                  </p>
                </div>
              </div>
            </a-layout-sider>
            <a-layout-content :style="{ paddingTop: '10px', minHeight: '280px' }">
              <h5 v-if="timelineData.length > 0">
                {{ practiceName }} | {{ studentName }}
              </h5>
              <div class="time-line-wrap">
                <Timeline
                  :timeline-data="timelineData"
                  :show-button="{
                    checkButton: true,
                    commentButton: true
                  }"
                  @handleGoCheck="handleGoCheck"
                />
              </div>
            </a-layout-content>
          </a-layout>
          <a-layout
            class="submain"
            v-if="status === '2'"
          >
            <a-tabs
              :default-active-key="activeKey"
              :animated="false"
              @change="handleTabChange"
            >
              <a-tab-pane
                key="2"
                tab="课本例练"
              />
              <a-tab-pane
                key="3"
                tab="双色笔记"
              />
              <a-tab-pane
                key="4"
                tab="日积月累"
              />
              <a-tab-pane
                key="5"
                tab="融会贯通"
              />
            </a-tabs>
            <div
              class="userbox"
              v-if="studentInfo.length > 0"
            >
              <span
                v-for="item in studentInfo[0].studentInfoList"
                :key="item.userId"
              >{{ item.userName }}</span>
            </div>
            <div class="empty" v-else>
              <a-empty />
            </div>
          </a-layout>
          <div
            class="submain"
            v-if="status === '3'"
          >
            <a-tabs
              :default-active-key="activeKey"
              :animated="false"
              @change="handleCheckedTabChange"
            >
              <a-tab-pane
                key="2"
                tab="课本例练"
              />
              <a-tab-pane
                key="3"
                tab="双色笔记"
              />
              <a-tab-pane
                key="4"
                tab="日积月累"
              />
              <a-tab-pane
                key="5"
                tab="融会贯通"
              />
            </a-tabs>
            <div class="subcontent" v-if="studentInfo.length > 0">
              <a-layout-sider
                class="check-detail-student"
                width="170"
                style="background: #fff"
              >
                <a-select
                  default-value="1"
                  style="width: 150px"
                  v-model="orderValue"
                  @change="handleSelectChange"
                >
                  <a-select-option value="1" title="按批改时间排序">
                    按批改时间排序
                  </a-select-option>
                  <a-select-option value="2" title="按打回订正优先排序">
                    按打回订正优先排序
                  </a-select-option>
                </a-select>
                <div
                  class="studentbox"
                  @click="handleGetStudentSubmitData"
                >
                  <div
                    v-for="(item, index) in studentInfo"
                    :key="index"
                  >
                    <p
                      v-for="(subItem, subIndex) in item.studentInfoList"
                      :key="subIndex"
                      :data-index="subIndex"
                      :data-ptindex="index"
                      :data-linktype="item.linkType"
                      :data-userid="subItem.userId"
                      :data-typename="item.linkTypeName"
                      :data-username="subItem.userName"
                      class="checked-student"
                      :ref="'stuChecked'+index+subIndex"
                    >
                      {{ subItem.userName }}
                      <em :class="{ 'em': subItem.teacherOperateType == 4}">{{ subItem.teacherOperateTypeName }}</em>
                    </p>
                  </div>
                </div>
              </a-layout-sider>
              <a-layout-content :style="{ paddingTop: '10px', paddingRight: '20px', minHeight: '280px' }">
                <h5 v-if="timelineData.length > 0">
                  {{ practiceName }} | {{ studentName }}
                </h5>
                <div class="time-line-wrap">
                  <Timeline
                    :timeline-data="timelineData"
                    :show-button="{
                      checkButton: false,
                      commentButton: true
                    }"
                    @handleGoCheck="handleGoCheck"
                  />
                </div>
              </a-layout-content>
            </div>
            <div class="empty" v-else>
              <a-empty />
            </div>
          </div>
        </a-layout-content>
      </a-layout>
    </div>
  </div>
</template>

<script>
import Timeline from '@/components/timeline.vue'
import correctLogger from '@/utils/logger/correct.js'
export default {
  name: 'InClass',

  components: {
    Timeline
  },

  data() {
    return {
      groupName: '',
      lessonName: '',
      lessonNum: '',
      status: '1',
      activeKey: '2',
      timelineData: [],
      studentInfo: [],
      practiceName: '',
      studentName: '',
      userId: '',
      // 当前选中的环节
      curIndex: 0,
      // 当前选中的学生
      curPtIndex: 0,
      // 排序的值
      orderValue: '1'
    }
  },
  created() {
    this.query = this.$route.query
  },
  mounted() {
    this.groupName = this.query.groupName
    this.lessonName = this.query.lessonName
    this.lessonNum = this.query.lessonNum
    this.getStudentlist()
  },
  methods: {
    handleClick(evt) {
      const loggerObj = {
        1: 'toCorrectLogger',
        2: 'notSubmitLogger',
        3: 'correctedLogger'
      }
      const { groupId, classTypeId, lessonId } = this.query
      correctLogger[loggerObj[evt.key]]({
        groupId,
        courseId: classTypeId,
        lessonId
      })
      this.status = evt.key
      this.activeKey = '2'
      this.studentInfo = []
      this.timelineData = []
      this.getStudentlist()
    },
    handleSelectChange(value) {
      this.orderValue = value
      this.getStudentlist({ orderType: +value })
    },
    handleGetStudentSubmitData(evt) {
      if (evt && evt.target.nodeName === 'H4') return
      if (evt && evt.target.nodeName === 'P') {
        const { linktype, typename, userid, username, index, ptindex } = evt.target.dataset
        this.practiceName = typename
        this.studentName = username
        this.activeKey = linktype
        this.userId = userid
        this.curIndex = index
        this.curPtIndex = ptindex
      }
      const params = {
        classTypeId: +this.query.classTypeId,
        lessonId: +this.query.lessonId,
        linkType: +this.activeKey,
        userId: +this.userId,
        pageSize: 100,
        pageNum: 1,
        type: 2
      }
      this.$service.correction.getStudentSubmitlist(params).then(result => {
        const { pathLogList } = result
        if (pathLogList) {
          this.timelineData = pathLogList.list
        } else {
          this.timelineData = []
        }
      })
    },
    handleTabChange(key) {
      this.activeKey = '' + key
      this.getStudentlist()
    },
    handleCheckedTabChange(key) {
      this.activeKey = '' + key
      this.getStudentlist()
    },
    handleGoCheck() {
      const { aiLessonId, groupId } = this.query
      this.$router.push({
        path: 'checktool',
        query: {
          userId: this.userId,
          classTypeId: +this.query.classTypeId,
          lessonId: +this.query.lessonId,
          xkhTeacherCourseId: +this.query.xkhTeacherCourseId,
          linkType: this.activeKey,
          groupName: this.groupName,
          lessonName: this.lessonName,
          lessonNum: this.lessonNum,
          aiLessonId,
          groupId
        }
      })
    },
    getStudentlist(data) {
      let linkType, orderType
      if (this.status != 1) {
        linkType = this.activeKey
      }
      if (this.status == 3) {
        orderType = 1
      }
      const params = {
        classTypeId: +this.query.classTypeId,
        lessonId: +this.query.lessonId,
        xkhTeacherCourseId: +this.query.xkhTeacherCourseId,
        classCorrectOptType: +this.status,
        linkType,
        orderType,
        ...data
      }
      this.studentInfo = []
      this.$service.correction.getCorrectionStudentlist(params).then(result => {
        if (result.length > 0) {
          this.studentInfo = result.map(item => {
            const { studentInfoList } = item
            return {
              ...item,
              studentInfoList: studentInfoList || []
            }
          })
          if (this.status != 2) {
            let index = 0
            // 如果第一个环节没有学生提交，则继续找下一个环节，如果找到，直接触发点击
            for (let i = 0; i < result.length; i++) {
              const item = result[i]
              if (item.studentInfoList && item.studentInfoList.length > 0) {
                index = i
                break
              }
            }
            this.curPtIndex = index
            this.curIndex = 0
            const data = result[index]
            //
            this.practiceName = data.linkTypeName
            this.studentName = data.studentInfoList && data.studentInfoList[0].userName
            this.activeKey = data.linkType
            this.userId = data.studentInfoList && data.studentInfoList[0].userId
            this.handleGetStudentSubmitData()
          }
        } else {
          this.studentInfo = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-content {
  height: 100%;
  background: #ffffff;
  .time-line-wrap {
      height: calc(100vh - 226px);
      overflow-y: scroll;
      overflow: overlay !important;
      &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: #242731;
      }
      &::-webkit-scrollbar-thumb{
          width: 6px;
          height: 6px;
          opacity: 0.8;
          border-radius: 3px;
          background: #C7C7C7;
      }
      &::-webkit-scrollbar-track {
          background: #fff;
      }
      &::-webkit-scrollbar-button {
          background: #fff;
      }
      &::-webkit-scrollbar-corner {
          background: #fff;
      }
  }
  .ant-page-header {
    padding: 5px;
    border-bottom: 1px solid #ebedf0;
  }
  .ant-layout-sider {
    height: calc(100vh - 163px);
    background-color: #ffffff;
    border-right: 1px solid #ebedf0;
    .ant-select {
      margin: 20px 0;
    }
  }
  .ant-layout-content {
    padding-left: 20px;
    background-color: #ffffff;
    overflow: unset;
    h5 {
      font-size: 18px;
      margin-bottom: 20px;
      padding-bottom: 5px;
      border-bottom: 1px solid #f1f1f1;
    }
    .submain {
      background: #fff;
      .userbox {
        span {
          display: inline-block;
          padding: 10px 20px;
          line-height: 1.5;
        }
      }
      .ant-tabs {
        height: auto;
        text-align: right;
        margin-top: -40px;
        padding-left: 0;
        :deep(.ant-tabs-content) {
          text-align: left;
          min-height: 1px;
        }
      }
      .subcontent {
        display: flex;
        padding-top: 2px;
        .studentbox {
          width: 157px;
          em {
            font-size: 12px;
          }
        }
      }
    }
  }
  .check-detail-student {
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #242731;
    }
    &::-webkit-scrollbar-thumb{
      width: 6px;
      height: 6px;
      opacity: 0.8;
      border-radius: 3px;
      background: #C7C7C7;
    }
    &::-webkit-scrollbar-track {
      background: #fff;
    }
    &::-webkit-scrollbar-button {
      background: #fff;
    }
    &::-webkit-scrollbar-corner {
      background: #fff;
    }
  }

  .main-content {
    padding: 0 20px;
  }
  .studentbox {
    width: 110px;
    line-height: 2;
    h4 {
      margin: 10px 0;
      border-bottom: 1px solid #f1f1f1;
    }
    p {
      cursor: pointer;
      .em {
        color: #ff0000;
      }
      &.active {
        color: #3262fd;
      }
      &.student-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .checked-student {
      display: flex;
      flex-direction: row;
      span {
        line-height: 36px;
        display: inline-block;
        width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      em {
        margin-left: 8px;
        display: inline-block;
      }
    }

  }
  :deep(.ant-tabs-ink-bar) {
    left: 7%;
  }
  .empty {
    margin-top: 20%;
  }
}
</style>